import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()({
  chartContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 auto',
  },
})

export default useStyles
